<template>
    <app-modal-view :fullwidth-header="true" @close="$emit('close')">
        <template #header>
            <section
                :class="{ 'has-background-very-light-pink-two': !event.image }"
                class="hero is-medium has-background"
            >
                <button
                    class="close is-pulled-left"
                    aria-label="close"
                    @click="$emit('close')"
                >
                    <span class="icon is-large">
                        <i class="mdi mdi-24px mdi-close has-text-white"></i>
                    </span>
                </button>
                <img
                    v-if="event.image"
                    :src="event.image.url"
                    alt
                    class="hero-background"
                />
                <div class="hero-body"></div>
            </section>
        </template>
        <template #body>
            <div class="lb-project-modal-content has-text-centered">
                <p class="title is-size-6 has-text-black is-uppercase mb-0">
                    <span class="icon">
                        <i class="far fa-lg fa-calendar-alt"></i>
                    </span>
                    <span class="category">{{
                        $t('Constants.EVENT_CATEGORY_EVENT')
                    }}</span>
                </p>
                <p class="title is-size-5 has-text-pink-red mb-0">
                    {{ eventDate }}h
                </p>
                <p class="title is-size-5 has-text-black mb-3">
                    {{ event.title }}
                </p>
                <AppCollapsableText
                    v-if="event.description"
                    :text="event.description"
                    class="lines-3"
                />
                <!--<p class="is-size-6 has-text-black">{{ event.description }}</p>-->
                <p class="is-size-6"></p>
                <div v-if="event.url" class="field">
                    <div class="control">
                        <div class="buttons is-centered">
                            <a
                                :href="event.url.url || event.url"
                                class="button is-primary mt-2 is-uppercase"
                                target="_blank"
                                >{{ event.url.title || event.url }}</a
                            >
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <template #footer>
            <div
                class="is-flex is-justify-content-flex-start"
                style="width: 100%"
            >
                <div>
                    <p>{{ $t('Community.import_to_my_calendar') }}</p>
                    <a
                        :href="googleLink"
                        :title="$t('Share.googleCalendar')"
                        target="_blank"
                    >
                        <span class="icon is-medium has-text-primary mr-2">
                            <i class="mdi mdi-24px mdi-google"></i>
                        </span>
                    </a>
                    <a
                        :href="outlookLink"
                        :title="$t('Share.outlook')"
                        target="_blank"
                    >
                        <span class="icon is-medium has-text-primary mr-2">
                            <i class="mdi mdi-24px mdi-microsoft-outlook"></i>
                        </span>
                    </a>
                    <a
                        :href="office365Link"
                        :title="$t('Share.office365')"
                        target="_blank"
                    >
                        <span class="icon is-medium has-text-primary mr-2">
                            <i class="mdi mdi-24px mdi-microsoft-office"></i>
                        </span>
                    </a>
                    <a :href="icsLink" :title="$t('Share.icsDownload')">
                        <span class="icon is-medium has-text-primary">
                            <i class="mdi mdi-24px mdi-download"></i>
                        </span>
                    </a>
                </div>
            </div>
            <div
                class="is-flex is-justify-content-flex-end"
                style="width: 100%"
            >
                <button
                    v-t="'Buttons.edit'"
                    class="button is-outlined is-primary px-5 is-uppercase"
                    @click="$emit('edit')"
                ></button>
                <button
                    v-t="'Buttons.delete'"
                    class="button is-outlined px-5 mx-2 is-danger is-uppercase"
                    @click="$emit('delete', event)"
                />
            </div>
        </template>
    </app-modal-view>
</template>

<script>
import AppModalView from '@/components/AppModalView';
import AppCollapsableText from '@/components/AppCollapsableText';
import moment from 'moment';
import { google, outlook, office365, ics } from 'calendar-link';

export default {
    components: {
        AppModalView,
        AppCollapsableText,
    },
    props: {
        event: {
            type: Object,
            default() {
                return {};
            },
            required: true,
        },
    },
    data: function () {
        return {};
    },
    computed: {
        eventDate() {
            return moment(this.event.range.start).format('DD/MM/YYYY H:mm');
        },
        eventData() {
            const eventStartDate = moment(this.event.range.start);
            const eventEndDate = moment(this.event.range.end);
            const eventDuration = eventStartDate.diff(eventEndDate, 'hours');
            return {
                title: this.event.title,
                description: this.event.description,
                start: this.event.range.start,
                end: this.event.range.end,
                duration: [eventDuration, 'hour'],
                allDay: eventDuration > 24 ? true : false,
                location: '',
                busy: false,
                guests: [],
                url: event.url ? event.url.url : '',
            };
        },
        googleLink() {
            return google(this.eventData);
        },
        outlookLink() {
            return outlook(this.eventData);
        },
        office365Link() {
            return office365(this.eventData);
        },
        icsLink() {
            return ics(this.eventData);
        },
    },
    methods: {},
};
</script>

<style scoped lang="sass">
.hero
  &.has-background
    position: relative
    overflow: hidden
  &-background
    position: absolute
    object-fit: cover
    object-position: center center
    width: 100%
    height: 100%
    &.is-transparent
      opacity: 0.3
</style>
<style scoped>
.lb-join-input input {
    height: 2em;
}
.lb-join-input button {
    width: 100%;
}
.lb-text-underline {
    text-decoration: underline;
}

.hero-body {
    z-index: 1;
}
.lb-community-partner-image {
    bottom: 1rem;
    left: 1rem;
    max-width: 200px;
}
.hero.has-background .close {
    z-index: 2;
    position: absolute;
    text-shadow: 2px 3px 2px rgb(0 0 0 / 50%);
}
.category {
    display: inline-block;
    padding-top: 0.3rem;
    vertical-align: top;
}
</style>
